import ShopifyEditor from './editor'

const { Shopify }: any = window

class BaseComponent extends HTMLElement {
  listeners: object
  editor: ShopifyEditor
  isEditorMode: boolean

  constructor() {
    super()

    this.editor = new ShopifyEditor()

    this.isEditorMode = Shopify.designMode
    this.listeners = {}
  }

  subscribe(eventName: string, listener: any): void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = []
    }

    this.listeners[eventName].push(listener)
  }

  unsubscribe(eventName: string, removedListener: any): void {
    if (!this.listeners[eventName]) {
      return
    }

    this.listeners[eventName] = this.listeners[eventName].filter(
      listener => listener !== removedListener,
    )
  }

  emit(eventName: string, data: any): void {
    if (!this.listeners[eventName]) {
      return
    }

    this.listeners[eventName].forEach(listener => listener(data))
  }
}

export default BaseComponent
